import { useMemo } from 'react';
import { getCurrentColor } from '../projects/const';

export const useThemeColor = (index) => {
  return useMemo(() => getCurrentColor(index), [index]);
};
